/**
 * data-ui-show-empty 属性から空の場合の表示設定を取得する
 * @returns true = 空でも表示する, false = 空の場合は非表示（デフォルト）
 */
export const parseShowEmpty = (root: HTMLElement): boolean => {
  return root?.dataset?.uiShowEmpty === 'true';
};
